import type * as lazyIndex from "./lazyIndex";
import { LazyImport, LazyModule, registerLazyOrchestrator, createLazyComponent, } from "owa-bundling";
import { showActionRestrictionDueToPolicy } from "./actions/showActionRestrictionDueToPolicy";
import { showUpdateRestrictionOnRegulatoryPolicy } from "./actions/showUpdateRestrictionOnRegulatoryPolicy";

// Create lazily loadable RetentionPolicies chunk.
const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "RetentionPolicies" */ "./lazyIndex"), { name: "RetentionPolicies" });

export const lazyOnArchiveTagForFolderChanged: LazyImport<typeof lazyIndex.onArchiveTagForFolderChanged, typeof lazyModule> = new LazyImport(lazyModule, m => m.onArchiveTagForFolderChanged);

export const lazyOnAssignPolicy: LazyImport<typeof lazyIndex.onAssignPolicy, typeof lazyModule> = new LazyImport(lazyModule, m => m.onAssignPolicy);

export const lazyOnDeleteTagForFolderChanged: LazyImport<typeof lazyIndex.onDeleteTagForFolderChanged, typeof lazyModule> = new LazyImport(lazyModule, m => m.onDeleteTagForFolderChanged);

export const lazyGetAssignPolicyPropertiesForMailContextMenu: LazyImport<typeof lazyIndex.getAssignPolicyPropertiesForMailContextMenu, typeof lazyModule> = new LazyImport(lazyModule, m => m.getAssignPolicyPropertiesForMailContextMenu);

export const lazyShouldSkipRequestToServerDueToPolicy: LazyImport<typeof lazyIndex.shouldSkipRequestToServerDueToPolicy, typeof lazyModule> = new LazyImport(lazyModule, m => m.shouldSkipRequestToServerDueToPolicy);

export const LazyRetentionPolicySubmenu: typeof lazyIndex.RetentionPolicySubmenu = createLazyComponent(lazyModule, m => m.RetentionPolicySubmenu);

registerLazyOrchestrator(showActionRestrictionDueToPolicy, lazyModule, m => m.showActionRestrictionDueToPolicyOrchestrator);

registerLazyOrchestrator(showUpdateRestrictionOnRegulatoryPolicy, lazyModule, m => m.showUpdateRestrictionOnRegulatoryPolicyOrchestrator);
